import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import ReportRedirectHandler from './ApplicationRedirectHandlers/ReportRedirectHandler';
import {
  canAccessReports,
  getPermitFeatureDeniedRedirect,
  isPermitFeatureTownshipAllowed
} from 'src/utils/permitFeatureAccess';

const ReportRoute = () => {
  const { townshipId, permit } = useParams<{ townshipId: string; permit: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const permitId = Number(permit);

  if (!canAccessReports(userDetails, permitId)) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isPermitFeatureTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <ReportRedirectHandler />;
};

export default ReportRoute;
